"use strict";
/**
 * 接口字段映射适配器
 * 根据schema协议，把接口返回的数据结构，映射成协议对应的新数据结构。
 * 支持嵌套的数组和对象映射
 * */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 根据 ”.“号连接符获取对象嵌套的值
 * @param {*} key 连接符key 如：key1.key2； 数组支持：key.1.***
 * @param {*} target 源对象
 */
function getValueByLinkKey(key, target) {
    var splits = key.split('.');
    return splits.reduce(function (acc, key) { return acc[key]; }, target);
}
/**
 * 递归适配
 * @param {Array} schemaItem 接口协议
 * @param {Object} source 递归接口源
 */
function applyAdapter(schemaItem, source) {
    if (schemaItem.schema) {
        if (schemaItem.type === 'array') {
            // 数组
            if (!schemaItem.sourceKey) {
                throw new Error("\u6570\u7EC4\u7C7B\u578B\u7F3A\u5C11sourceKey\u5B57\u6BB5\uFF1A".concat(JSON.stringify(schemaItem)));
            }
            return source[schemaItem.sourceKey].map(function (arrayItem) { return apiAdapter(schemaItem.schema, arrayItem); });
        }
        return apiAdapter(schemaItem.schema, schemaItem.sourceKey ? source[schemaItem.sourceKey] : source);
    }
    // 无子协议，必须要有sourceKey，直接映射
    if (!schemaItem.sourceKey) {
        throw new Error("\u7F3A\u5C11sourceKey\u5B57\u6BB5: ".concat(JSON.stringify(schemaItem)));
    }
    return getValueByLinkKey(schemaItem.sourceKey, source);
}
/**
 * 接口适配器
 * @param {Array} schema 接口协议
 * @param {Object} source 接口源数据
 * @retrun 返回适配后的数据
 */
function apiAdapter(schema, source) {
    var result = {};
    for (var key in schema) {
        var schemaItem = schema[key];
        result[key] = applyAdapter(schemaItem, source);
    }
    return result;
}
exports.default = apiAdapter;
